module.exports = __webpack_public_path__ + "img/28.5.COD.d70fea62.png";